import {
  ReportBuilderFlowType,
  useInReportBuilderFlowType,
} from '../../hooks/useInReportBuilderFlowType';
import { CustomReportsConfirmation } from './custom-reports/custom-reports-confirmation';
import { MwReportConfirmation } from './mw-reports/mw-report-confirmation';

export const ReportConfirmation = () => {
  const reportBuilderFlowType = useInReportBuilderFlowType();

  return (
    <>
      {reportBuilderFlowType === ReportBuilderFlowType.MiddlewareReports && (
        <MwReportConfirmation />
      )}
      {reportBuilderFlowType === ReportBuilderFlowType.CustomReports && (
        <CustomReportsConfirmation />
      )}
    </>
  );
};
